import Controller from "./paymentMethod.controller";
import template from "./paymentMethod.html";

const paymentMethod = {
  template,
  controller: Controller,
};

export default paymentMethod;



// WEBPACK FOOTER //
// ./src/pages/paymentMethod/paymentMethod.component.js